import { render } from "./ArchaicUpgrade.vue?vue&type=template&id=0ac300d0"
import script from "./ArchaicUpgrade.vue?vue&type=script&lang=js"
export * from "./ArchaicUpgrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__